import { Box, Flex, Heading, Text, Link as ChakraLink } from '@chakra-ui/react';
import Image from 'next/image';
import useTranslation from 'next-translate/useTranslation';
import Link from 'next/link';
import { handleGTMClick } from '@/helpers/handleGTMClick';

type Props = {
  title: string;
  icon: string;
  /* eslint-disable */
  url?: string;
};

interface PathButtonIds {
  [key: string]: string;
}

const ITEM_PATH_TO_ID: PathButtonIds = {
  '/cenarios/seo-para-startups': 'scenario_startups',
  '/cenarios/seo-para-lojas-virtuais': 'scenario_ecommerce',
  '/cenarios/migracao-de-sites': 'scenario_migration',
  '/cenarios/auditoria-de-seo': 'scenario_audit',
  '/cenarios/seo-para-blogs': 'scenario_blogs',
  '/servicos/consultoria-em-seo': 'scenario_seo',
  '/servicos/local-seo': 'scenario_local_seo',
  '/servicos/conteudo': 'scenario_content',
  '/servicos/digital-analytics': 'scenario_analytics',
  '/politica-de-privacidade': 'scenario_privacy',
};

function Compoment({ title, icon }: Props) {
  return (
    <Flex
      direction="column"
      bgColor="#F1F6FF"
      gap="16px"
      p="24px"
      alignItems="center"
      minW="198px"
      h="160px"
      borderRadius="8px"
    >
      <Image src={icon} alt="icon" width={49} height={49} />
      <Text fontSize="16px" lineHeight="24px" fontWeight="600" color="#4A5568" textAlign="center">
        {title}
      </Text>
    </Flex>
  );
}

export default function ProjectScenarios() {
  const { t } = useTranslation('services');

  const scenarios: Props[] = [
    {
      title: 'Migração de sites',
      icon: '/images/project-scenarios/icon1.svg',
      url: '/cenarios/migracao-de-sites',
    },
    {
      title: 'Auditoria de SEO',
      icon: '/images/project-scenarios/icon2.svg',
      url: '/cenarios/auditoria-de-seo',
    },
    {
      title: 'SEO para Startups',
      icon: '/images/project-scenarios/icon3.svg',
      url: '/cenarios/seo-para-startups',
    },
    {
      title: 'SEO para Lojas Virtuais',
      icon: '/images/project-scenarios/icon4.svg',
      url: '/cenarios/seo-para-lojas-virtuais',
    },
    {
      title: 'SEO para blogs',
      icon: '/images/project-scenarios/icon5.svg',
      url: '/cenarios/seo-para-blogs',
    },
  ];

  return (
    <Flex
      direction="column"
      maxWidth="1216px"
      margin="0 auto"
      width={{ base: '90%', lg: '100%' }}
      mb="32px"
      gap="72px"
      pt={{ base: '40px', lg: '72px' }}
      pb={{ base: '40px', lg: '72px' }}
    >
      <Flex direction="column" justifyContent="center" gap="16px">
        <Heading
          as="h2"
          width="90%"
          fontSize={{ base: '36px', lg: '48px' }}
          lineHeight={{ base: '40px', lg: '48px' }}
          fontWeight="800"
          color="blue.900"
          ml={{ base: '0', lg: '0' }}
        >
          {t('seoConsulting.projectScenarios.title')}
        </Heading>
        <Text fontSize="16px" lineHeight="24px" color="gray.600">
          {t('seoConsulting.projectScenarios.description1')}
        </Text>
        <Flex position="relative">
          <Box
            style={{ pointerEvents: 'none' }}
            display={{ base: 'flex', lg: 'none' }}
            position="absolute"
            h="180px"
            w="158px"
            right="0"
            top="40px"
            bg="linear-gradient(270deg, #FAFDFF 0%, rgba(255, 255, 255, 0.00) 100%)"
            zIndex={3}
          />
        </Flex>
        <Flex
          gap={{ base: '16px', lg: '56px' }}
          mt="32px"
          overflowX="scroll"
          css={{
            '&::-webkit-scrollbar': {
              display: 'none',
            },
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
          }}
          position="relative"
        >
          {scenarios.map((scenario: Props, index: number) => (
            <ChakraLink
              id={ITEM_PATH_TO_ID[scenario.url!]}
              onClick={handleGTMClick}
              onAuxClick={handleGTMClick}
              as={Link}
              href={scenario.url}
              p="0 !important"
              key={index}
            >
              <Compoment title={scenario.title} icon={scenario.icon} />
            </ChakraLink>
          ))}
        </Flex>
        <Text fontSize="16px" lineHeight="24px" color="gray.600">
          {t('seoConsulting.projectScenarios.description2')}
        </Text>
      </Flex>
    </Flex>
  );
}
